import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  groupWrapper: {
    width: '100%',
    minHeight: '60px',
    backgroundColor: 'whitesmoke',
    color: 'black',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '5px',
    padding: '25px 15px 25px 15px',
  },
  groupHeader: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: '10px',
  },
  groupTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  groupOption: {
    fontSize: '15px',
  },
  groupCenterWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  groupDraggingPlaceholder: {
    opacity: 0.4,
    border: '2px dashed #ff4d4f',
    pointerEvents: 'none',
    transition: 'all 0.2s ease-in-out',
  },
});
